import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'help-shell',
    template: require('./help.shell.component.html'),
    styles: [require('./help.shell.component.css')]
})
export class HelpShellComponent implements OnInit {
    constructor(private readonly route: ActivatedRoute, private readonly router: Router) { }

    ngOnInit() {
        this.route.queryParams.subscribe(params => {
            const tab = (params && params.tab ? params.tab : '').toString();
            if (tab === 'bidManagement') {
                this.router.navigate(['/help/bid-management'], { replaceUrl: true });
            } else if (tab === 'tenders' && this.router.url.indexOf('/help/tenders') === -1) {
                this.router.navigate(['/help/tenders'], { replaceUrl: true });
            }
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/account.management/help/help.shell.component.ts